import { FC } from "react";
import { IconPropsType } from ".";

export const RelationArrow: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0V5.14286C9 6.47619 8.13848 9.14286 4.69238 9.14286C1.24628 9.14286 4.4461 9.14286 1 9.14286M1 9.14286C2.84613 7.42857 4.07701 6.28571 4.07701 6.28571M1 9.14286C2.84613 10.8571 4.07701 12 4.07701 12"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
